import React from 'react';
import * as helper from '../../../Common/html-helper';
import * as setHelper from './flexible-set-mapper';
import { FlexibleSetsWrapperProps } from '../searchresultpage.d';
import ArrowDownIcn from '../../../Assets/svg/arrow_down';
import FspTileGrid from '../../flexSets/fspTileGrid/fsp-tile-grid';
import styles from './flexible-set-list-wrapper.scss';

const FlexibleSetListWrapper = (props: FlexibleSetsWrapperProps) => {
    const tabNavAttribute = { focusable: true };
    const gridRef = React.createRef<HTMLDivElement>();
    const placeholderCategory = setHelper.getPlaceholderCategory();
    const flexibleSetTilePrices = props.flexibleSetContext.flexibleSets.map((set) => set.price);
    const flexibleSetTileGridData = setHelper.mapToFlexibleSetTiles(props.flexibleSetContext.flexibleSets);
    const buttonInfo = props.flexibleSetContext.flexSetButton;
    const buttonText = helper.decodeHTML(props.l10n.viewAllResults);
    const setHeadlineText =
        props.l10n.startQuotationMark +
        props.searchTerm +
        props.l10n.endQuotationMark +
        ' ' +
        helper.decodeHTML(props.l10n.searchTermInSets) +
        ':';

    // event deactivated: waiting for OM feedback
    // const handleTelemetry = () => {
    //     if (!buttonInfo.telemetryData.stm) return;
    //     const data = new SearchTelemetryData(
    //         buttonInfo.telemetryData.stm,
    //         PageViewLogDataId.getInstance().get(),
    //         props.portal,
    //         props.culture,
    //         props.magicLink
    //     );
    //     SearchTelemetryAjaxCaller.postData(data);
    // };

    const handleTabNavigation = (
        event: React.KeyboardEvent<HTMLAnchorElement>
    ) => {
        if (event.key === ' ') {
            event.preventDefault(); // prevent page jump
            event.currentTarget?.click();
        }
    };

    return (
        <div className={styles.flexible_set_list_wrapper}>
            <div className={styles.flex_sets_divider}>
                <span className={styles.headline} 
                    dangerouslySetInnerHTML={{ __html: setHeadlineText }}>
                </span>
            </div>

            <FspTileGrid
                currencyInformation={props.flexibleSetContext.setCurrencyInformation}
                flexSets={flexibleSetTileGridData}
                setPrice={flexibleSetTilePrices}
                category={placeholderCategory}
                l10n={props.l10n}
                kiosk={props.kiosk}
                isMobile={props.isMobile}
                isGlobal={props.isGlobal}
                gridRef={gridRef}
                addItemOriginToPdpLink={false}
                portal={props.portal}
                culture={props.culture}
            />

            <div className={styles.sets_button_container}>
                <div className={styles.sets_button_wrapper}>
                    <a
                        className={styles.sets_button}
                        href={buttonInfo.flexSetBaseCategoryLink}
                        data-stm={buttonInfo.telemetryData.stm}
                        {...tabNavAttribute}
                        // onClick={() => handleTelemetry()}
                        onKeyDown={(e) => handleTabNavigation(e)}
                        aria-label={buttonText}
                    >
                        <span>{buttonText}</span>
                        <ArrowDownIcn />
                    </a>
                </div>
            </div>
        </div>
    );
};

export default FlexibleSetListWrapper;
